/* eslint react/jsx-pascal-case:0 */

import { useEffect, useMemo, useState, useContext, createRef } from 'react';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import { 
  Avatar,
  Box, 
  Switch,
  Tooltip,
  IconButton,
  Grid,
  Typography,
  useMediaQuery,
  Link,
} from '@mui/material';
import {
  ConstructionOutlined,
  ContactSupportOutlined,
  DragIndicator as DragIndicatorIcon,
  Edit as EditIcon,
  FilterAltOff as FilterAltOffIcon,
  OpenInNew as OpenInNewIcon,
  SyncAlt as SyncAltIcon,
} from '@mui/icons-material';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { 
  MaterialReactTable, 
  useMaterialReactTable, 
  MRT_ShowHideColumnsButton, MRT_ToggleFullScreenButton, MRT_ToggleGlobalFilterButton, MRT_ToggleFiltersButton
} from 'material-react-table';

import {
  ShopifyIcon
} from 'components/Icons';
import { Layout as DashboardLayout } from 'layouts/portal/layout';
import { Tracking } from 'components/Tracking';
import { AuthContext, Product, FAB, availableCategoryGroups } from "components";
import { photo_url } from 'config'
import { useLocalStorage } from 'hooks/use-local-storage'

const DEFAULT_COLUMN_VISIBILITY = {
  image: true,
  brands: true,
  department: false,
  category: true,
  color: true,
  price: true,
  retailPrice: true,
  quantity: true,
  deliveryStart: true,
  deliveryEndDate: false,
  collection: false,
  note: false,
  orderNumber: false,
  styleNumber: false,
  styleName: false,
  orderStatus: false,
  deliveries: true,
}

const DEFAULT_PAGINATION = {
  pageIndex: 0,
  pageSize: 25
}

MRT_Localization_EN.edit = 'Product Details'
MRT_Localization_EN.selectedCountOfRowCountRowsSelected = '{selectedCount} of {rowCount} product(s) selected'

const ColorComponent = (props) => {
  const { 
    color, 
    text,
    selected = true,
    size = 20,
  } = props

  const handleClick = function() {
    if (props.onClick) {
      props.onClick(color)
    }
  }

  const style = {
    MozUserSelect: "none",
    WebkitUserSelect: "none",
    msUserSelect: "none",
    width: `${size}px`,
    height: `${size}px`,
    margin: '0 5px',
    cursor: 'pointer',
    // border: `1px solid ${selected ? 'black' : 'white'}`,
    borderRadius: '50%',
    boxShadow: selected ? '0px 0px 10px 5px #6366F1' : 'none',
  }

  if (color.imageName) {
    let color_img = `https://firebasestorage.googleapis.com/v0/b/faves-pro.appspot.com/o/colors%2F${color.imageName}.png?alt=media`

    return (
      <Grid style={{ width: 'auto' }} container spacing={1}>
        <Grid item>
          <img 
            style={style}
            src={color_img} 
            alt=''
            onClick={handleClick}
            onError={(e) => {
              console.log(e)
              console.log(color)
            }}
          />
        </Grid>
        <Grid item>
          <span>{text}</span>
        </Grid>
      </Grid>
    )
  }
  return (
    <Grid style={{ width: 'auto' }} container spacing={1}>
        <Grid item>
          <div onClick={handleClick} key={color && color.displayName} style={{ 
            ...style,
            background: `#${color && color.hex}`
          }}></div>
        </Grid>
        <Grid item>
          <span>{text}</span>
        </Grid>
      </Grid>
  )
}

export const Products = () => {
  const [ visibleItems, setVisibleItems ] = useState([]);
  const [ filteredItems, setFilteredItems ] = useState([]);
  const [ rowSelection, setRowSelection ] = useLocalStorage('products-row-selection', {});
  const [ selectedItems, setSelectedItems ] = useLocalStorage('products-selected-items', []);
  const [ availableBrands, setAvailableBrands ] = useState([]);
  const [ availableDepartments, setAvailableDepartments ] = useState([]);
  const [ availableCategories, setAvailableCategories ] = useState([]);
  const [ columnFilters, setColumnFilters ] = useLocalStorage('products-column-filters', []);
  const [ columnOrder, setColumnOrder ] = useLocalStorage('products-column-order', []);
  const [ globalFilter, setGlobalFilter ] = useLocalStorage('products-global-filters', '');
  const [ sorting, setSorting ] = useLocalStorage('products-sort-order', []);
  const [ isFullScreen, setIsFullScreen ] = useState(false);
  const [ editableProduct, setEditableProduct ] = useState(false);
  const [ shopifyFilterOptions, setShopifyFilterOptions ] = useState([
    { text: 'Sent to Shopify', value: 'yes' },
    { text: 'Not in Shopify', value: 'no' },
  ]);
  const [ selectedCategoryGroups, setSelectedCategoryGroups ] = useState([]);
  const [ columnVisibility, setColumnVisibility ] = useLocalStorage('column-visibility', DEFAULT_COLUMN_VISIBILITY)
  const [ pagination, setPagination ] = useLocalStorage('products-pagination', DEFAULT_PAGINATION)
  const navigate = useNavigate();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  // const [ x, forceUpdate] = useReducer(x => x + 1, 0)

  // Reset default column visibility
  // useEffect(() => { setColumnVisibility(DEFAULT_COLUMN_VISIBILITY) }, [])
  // eslint-disable-next-line no-unused-vars
  const { accountId, selectedSeasonitems, brands, collections, userCreatedBrands, updateItem, selectedSeason, customCategories, colors, selectedCollection, accountIntegrations } = useContext(AuthContext);
  // console.log('selectedItems', selectedItems)
  // console.log('collections', collections)
  // console.log('selectedSeason', selectedSeason)
  console.log('selectedItems', selectedItems.map(e => e.id))
  // console.log('items', items)
  // console.log('accountIntegrations', accountIntegrations)
  // console.log('colors', colors)
  // console.log('brands', brands)
  // console.log('userCreatedBrands', userCreatedBrands)
  // console.log('customCategories', customCategories)
  // console.log('rowSelection', rowSelection)
  // console.log('currentUser', currentUser)
  // console.log('customCategories', customCategories)

  useEffect(() => { 
    Tracking.track('Portal - Products')
  }, [])
  
  useEffect(() => { 
    let shopify_filter_options = [
      { text: 'Sent to Shopify', value: 'yes' },
      { text: 'Not in Shopify', value: 'no' },
    ]

    let shopify_stores = Object.keys(accountIntegrations?.shopify_v2 || {})
    if (shopify_stores.length > 1) {
      shopify_stores.forEach(e => {
        shopify_filter_options.push({
          value: e,
          text: `Sent to ${accountIntegrations?.shopify_v2?.[e]?.name || e}`
        })
      })
    }

    setShopifyFilterOptions(shopify_filter_options)
  }, [accountIntegrations])

  useEffect(() => {
    setAvailableBrands([...new Set(visibleItems.map((e) => e.brand))].map((e) => ({
      text: (userCreatedBrands?.[e]?.displayName) || (brands?.[e]?.displayName) || "",
      value: e,
    })))
  }, [visibleItems, brands, userCreatedBrands])
  
  useEffect(() => {
    if (!customCategories) return

    setAvailableDepartments([...new Set(visibleItems.filter((e) => e.hasOwnProperty('categoryType')).map((e) => availableCategoryGroups[e.categoryType]))].sort((a, b) => availableCategoryGroups.indexOf(a) > availableCategoryGroups.indexOf(b) ? 1 : -1))
    let department = columnFilters.filter((e) => e.id === 'department')?.[0]?.value || false;
    setAvailableCategories([...new Set(visibleItems.filter((e) => e?.categoryId && customCategories.hasOwnProperty(e?.categoryId)).map((e) => e.categoryId))].map((e) => {
      return {
        id: e,
        value: customCategories[e].category,
        department: customCategories[e].category_group,
        sorting: customCategories[e].sorting
      }
    }).filter((e) => {
        if (department) {
          return e.department === department
        }
        return e.value
    }).sort((a, b) => {
      if (availableCategoryGroups.indexOf(a.department) > availableCategoryGroups.indexOf(b.department)) {
        return 1
      }
      if (availableCategoryGroups.indexOf(b.department) > availableCategoryGroups.indexOf(a.department)) {
        return -1
      }

      return a.sorting?.indexOf(a.id) > b.sorting?.indexOf(b.id) ? 1 : -1
    }) || [])
  }, [visibleItems, customCategories, columnFilters])

  useEffect(() => {
    if (!customCategories) return
    setSelectedCategoryGroups([...new Set(Object.keys(customCategories).map((e) => customCategories[e].category_group))])
  }, [customCategories])

  const clearSelection = () => {
    setRowSelection([])
    setSelectedItems([])
  }

  const reset_visible_items = () => {
    const selected_items = selectedSeasonitems
    let visible_items = Object.keys(selected_items).map((e) => {
      return {
        id: e,
        ...selected_items[e]
      }
    });
    
    if (globalFilter) {
      visible_items = visible_items.filter((item) => {
        const note_found = item.note && item.note?.toLowerCase().indexOf(globalFilter?.toLowerCase()) !== -1
        const styleNumber_found = item.styleNumber && item.styleNumber?.toLowerCase().indexOf(globalFilter?.toLowerCase()) !== -1
        const styleName_found = item.styleName && item.styleName?.toLowerCase().indexOf(globalFilter?.toLowerCase()) !== -1
        const brand = (userCreatedBrands?.[item.brand]?.displayName) || (brands?.[item.brand]?.displayName) || "";
        const brand_found = brand?.toLowerCase().indexOf(globalFilter?.toLowerCase()) !== -1
        const category = (customCategories[item.categoryId] && customCategories[item.categoryId]?.category) || ""
        const category_found = category?.toLowerCase().indexOf(globalFilter?.toLowerCase()) !== -1
        const colors_found = item?.color?.map((i) => colors[i]).filter(e => e?.displayName?.toLowerCase().indexOf(globalFilter?.toLowerCase()) !== -1)

        if (note_found || styleName_found || styleNumber_found || brand_found || category_found || colors_found?.length) {
          return true
        }

        return false
      })
    }

    const selected_item_order = Object.keys(selected_items)

    visible_items.sort((a, b) => {
      const a_id = selected_item_order.indexOf(a.id)
      const b_id = selected_item_order.indexOf(b.id)
      if (a_id > b_id) {
        return -1;
      }
      if (a_id < b_id) {
        return 1;
      }
    
      return 0;
      // return b.id.localeCompare(a.id)
    });

    if (selectedCollection === 'all') {
      setVisibleItems(visible_items)
    } else if (selectedCollection === '-') {
      setVisibleItems(visible_items.filter((e) => !e.collectionId))
    } else {
      setVisibleItems(visible_items.filter((e) => e.collectionId === selectedCollection))
    }

  }

  useEffect(() => {
    if (selectedSeasonitems) {
      reset_visible_items()
    } else {
      setVisibleItems([])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSeasonitems, collections, selectedSeason, selectedCollection, globalFilter])

  const columns = useMemo(() => [
    { id: 'image', 
      accessorKey: 'photos',
      header: 'Image', 
      enableSorting: false,
      enableColumnFilter: false,
      enableColumnActions: false,
      enableColumnFilterModes: false,
      size: 50,
      Cell: ({ cell }) => (
        <Avatar variant="square" src={cell.getValue() ? `${photo_url}/o/${accountId}%2F${cell.getValue()[0]}.jpg?alt=media` : ""} />
      )
    },
    { 
      id: 'brand', 
      accessorKey: 'brand',
      header: 'Brand', 
      enableColumnFilterModes: false,
      // filterSelectOptions: [...availableBrands.map((e) => e.text)],
      muiFilterAutocompleteProps: {
        options: [...availableBrands.map((e) => {
          return {
            value: e.text,
            group: brands.hasOwnProperty(e.value) ? 'All' : 'Personal'
          }
        })].filter((e) => e.value).sort((a, b) => {
          if (a.group === b.group) {
            if (a.value < b.value) {
              return -1;
            } else if (a.value > b.value) {
              return 1;
            } else {
              return 0;
            }
          }

          return a.group === 'Personal' ? -1 : 1
        }),
        groupBy: (option) => option.group,
      },
      sortingFn: (rowA, rowB, columnId) => {
        let a = userCreatedBrands?.[rowA.original[columnId]]?.displayName || brands?.[rowA.original[columnId]]?.displayName || "";
        let b = userCreatedBrands?.[rowB.original[columnId]]?.displayName || brands?.[rowB.original[columnId]]?.displayName || "";
        return (a===null)-(b===null) || +(a>b)||-(a<b);
      },
      filterVariant: 'autocomplete',
      filterFn: (row, id, filterValue) => filterValue === userCreatedBrands?.[row.original.brand]?.displayName || filterValue === brands?.[row.original.brand]?.displayName,
      Cell: ({ cell }) => (<span>{(userCreatedBrands?.[cell.getValue()] && userCreatedBrands?.[cell.getValue()].displayName) || (brands?.[cell.getValue()] && brands?.[cell.getValue()].displayName) || ""}</span>),
    },
    { 
      id: 'department', 
      accessorKey: 'categoryType',
      header: 'Department', 
      enableColumnFilterModes: false,
      muiFilterAutocompleteProps: {
        // options: availableCategoryGroups,
        options: availableDepartments,
      },
      filterVariant: 'autocomplete',
      sortingFn: (rowA, rowB, columnId) => {
        let a = availableCategoryGroups?.[rowA.original['categoryType']]?.toLowerCase() || "";
        let b = availableCategoryGroups?.[rowB.original['categoryType']]?.toLowerCase() || "";
        return (a===null)-(b===null) || +(a>b)||-(a<b);
      },
      filterFn: (row, id, filterValue) => customCategories[row.original.categoryId]?.category_group === filterValue,
      Cell: ({ cell }) => (<span>{availableCategoryGroups?.[cell.getValue()] || ""}</span>),
    },
    { 
      id: 'category', 
      accessorKey: 'categoryId',
      header: 'Category', 
      enableColumnFilterModes: false,
      muiFilterAutocompleteProps: {
        options: availableCategories,
        groupBy: (option) => option.department,
      },
      sortingFn: (rowA, rowB, columnId) => {
        let a = customCategories?.[rowA.original['categoryId']]?.category || "";
        let b = customCategories?.[rowB.original['categoryId']]?.category || "";
        return (a===null)-(b===null) || +(a>b)||-(a<b);
      },
      filterVariant: 'autocomplete',
      filterFn: (row, id, filterValue) => customCategories[row.original.categoryId]?.category === filterValue,
      Cell: ({ cell }) => (<span>{(customCategories[cell.getValue()] && customCategories[cell.getValue()].category) || ""}</span>),
    },
    { 
      id: 'color', 
      accessorKey: 'color',
      accessorFn: (e) => {
        if (e.color) {
          return e.color.map((i) => colors[i])
        }
        return []
      },
      header: 'Color', 
      enableColumnFilterModes: false,
      muiFilterAutocompleteProps: {
        options: Object.keys(colors).map(color_id => ({
          label: colors[color_id].displayName,
          value: colors[color_id].id,
        })),
        getOptionLabel: (e) => e.label || "",
      },
      filterSelectOptions: Object.keys(colors).map(color_id => ({
        label: colors[color_id].displayName,
        value: parseInt(colors[color_id].id),
      })).sort((a, b) => {
        if (a.label < b.label) {
          return -1
        }
        if (a.label > b.label) {
          return 1
        }
        return 0
      }),
      filterVariant: 'multi-select',
      filterFn: 'colorFilter',
      Cell: ({ cell }) => {
        return (
          <div style={{ display: "flex" }}>
            {cell.getValue().map((color) => {
              return (<ColorComponent 
                key={`color-${color.id}`}
                color={colors[color.id]}
                selected={false}
                size={20}
              />)
            })}
          </div>
        )
      },
    },
    { 
      id: 'price',
      // accessorKey: 'priceInfo.price',
      accessorFn: (e) => e.priceInfo?.price ? parseFloat(e.priceInfo?.price || 0)?.toFixed(2) : undefined,
      enableColumnFilterModes: false,
      header: 'Cost Price',
      sortDescFirst: true,
      invertSorting: true,
      sortingFn: (rowA, rowB) => {
        let b = rowA.original?.['priceInfo']?.['price']
        let a = rowB.original?.['priceInfo']?.['price']
        return (a===null)-(b===null) || +(a>b)||-(a<b);
      },
      // columnFilterModeOptions: ['between', 'lessThan', 'greaterThan'],
    },
    { 
      id: 'retailPrice',
      // accessorKey: 'priceInfo.retailPrice',
      accessorFn: (e) => e.priceInfo?.retailPrice ? parseFloat(e.priceInfo?.retailPrice)?.toFixed(2) : undefined,
      enableColumnFilterModes: false,
      header: 'Retail Price',
      columnFilterModeOptions: ['between', 'lessThan', 'greaterThan'],
      sortDescFirst: true,
      invertSorting: true,
      sortingFn: (rowA, rowB) => {
        let b = rowA.original?.['priceInfo']?.['retailPrice']
        let a = rowB.original?.['priceInfo']?.['retailPrice']
        return (b===null)-(a===null) || +(a>b)||-(a<b);
      },
    },
    { 
      id: 'markup',
      accessorFn: (e) => e.priceInfo?.markup ? parseFloat(e.priceInfo?.markup)?.toFixed(2) : undefined,
      enableColumnFilterModes: false,
      header: 'Markup',
      sortDescFirst: true,
      invertSorting: true,
      sortingFn: (rowA, rowB) => {
        let b = rowA.original?.['priceInfo']?.['markup']
        let a = rowB.original?.['priceInfo']?.['markup']
        return (b===null)-(a===null) || +(a>b)||-(a<b);
      },
      columnFilterModeOptions: ['between', 'lessThan', 'greaterThan'],
    },
    { 
      id: 'quantity',
      accessorFn: (e) => e.priceInfo?.quantity || undefined,
      enableColumnFilterModes: false,
      header: 'Quantity',
      columnFilterModeOptions: ['between', 'lessThan', 'greaterThan'],
      sortDescFirst: true,
      invertSorting: true,
      sortingFn: (rowA, rowB, columnId) => {
        let b = rowA.original?.['priceInfo']?.['quantity']
        let a = rowB.original?.['priceInfo']?.['quantity']
        console.log(a, b)
        return (b===null)-(a===null) || +(a>b)||-(a<b);
      },
    },
    { 
      id: 'deliveryStart', 
      accessorKey: 'deliveryStart', 
      accessorFn: (e) => e.deliveryStart && moment(e.deliveryStart * 1000).isValid() ? moment(e.deliveryStart * 1000).format("MMM YYYY") : undefined,
      header: 'Delivery Start',
      filterVariant: 'date',
      sortingFn: 'dateSort',
      filterFn: (row, id, filterValue) => { 
        let m_start = moment(filterValue).date(1).hour(0).minute(0).second(0).unix()
        let m_end = moment(filterValue).date(1).hour(0).minute(0).second(0).add(1, 'months').subtract(1, 'days').unix()
        return m_start <= row.original[id] && m_end >= row.original[id]
        // let current = moment(row.getValue(id)).utc().date(1).hour(0).minute(0).second(0);
        // let start_date = filterValue[0] && filterValue[0].utc().date(1).hour(0).minute(0).second(0);
        // let end_date = filterValue[1] && filterValue[1].utc().date(1).hour(0).minute(0).second(0);
        
        // if (start_date && end_date) {
        //   return start_date <= current && current <= end_date;
        // }

        // if (start_date) { return start_date <= current }
        // if (end_date) { return end_date >= current }
      },
      muiFilterDatePickerProps: {
        views: ['month', 'year'],
        format: "MMM YYYY",
        localeText: {
          fieldMonthPlaceholder: () => "MMM"
        }
      },
      // enableColumnFilter: false,
      enableColumnFilterModes: false,
    },
    { 
      id: 'deliveryEndDate', 
      accessorKey: 'deliveryEndDate', 
      accessorFn: (e) => e.deliveryEndDate && moment(e.deliveryEndDate * 1000).isValid() && moment(e.deliveryEndDate * 1000) > moment(e.deliveryStart * 1000) ? moment(e.deliveryEndDate * 1000).format("MMM YYYY") : undefined,
      header: 'Delivery End',
      filterVariant: 'date',
      sortingFn: 'dateSort',
      filterFn: (row, id, filterValue) => { 
        let m_start = moment(filterValue).date(1).hour(0).minute(0).second(0).unix()
        let m_end = moment(filterValue).date(1).hour(0).minute(0).second(0).add(1, 'months').subtract(1, 'days').unix()
        return m_start <= row.original[id] && m_end >= row.original[id]
        // let current = moment(row.getValue(id)).utc().date(1).hour(0).minute(0).second(0);
        // let start_date = filterValue[0] && filterValue[0].utc().date(1).hour(0).minute(0).second(0);
        // let end_date = filterValue[1] && filterValue[1].utc().date(1).hour(0).minute(0).second(0);
        
        // if (start_date && end_date) {
        //   return start_date <= current && current <= end_date;
        // }

        // if (start_date) { return start_date <= current }
        // if (end_date) { return end_date >= current }
      },
      muiFilterDatePickerProps: {
        views: ['month', 'year'],
        format: "MMM YYYY",
        localeText: {
          fieldMonthPlaceholder: () => "MMM"
        }
      },
      enableColumnFilterModes: false,
    },
    { 
      id: 'collection', 
      accessorFn: (e) => collections[e?.collectionId ?? '-']?.displayName ?? '-', 
      header: 'Collection', 
      enableColumnFilterModes: false 
    },
    { id: 'styleNumber', accessorKey: 'styleNumber', header: 'Style Number', enableColumnFilterModes: false },
    { id: 'styleName', accessorKey: 'styleName', header: 'Style Name', enableColumnFilterModes: false },
    { id: 'orderNumber', accessorKey: 'orderNumber', header: 'Order Number', enableColumnFilterModes: false },
    { 
      id: 'note',
      accessorKey: 'note',
      header: 'Note',
      enableColumnFilterModes: false,
      filterFn: (row, id, filterValue) => { 
        return row.getValue(id) && row.getValue(id)?.toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1
      },
      filterVariant: 'text',
      muiTableBodyCellProps: {
        sx: {
          textOverflow: 'ellipsis',
          maxWidth: '300px'
        }
      },
      muiEditTextFieldProps: {
        multiline: true,
      },
    },
    { 
      id: 'orderStatus',
      accessorKey: 'orderStatus',
      accessorFn: (e) => e.orderStatus ? e.orderStatus : 'no',
      header: 'Commited',
      enableColumnFilterModes: false,
      enableSorting: false,
      filterVariant: 'select',
      muiFilterSelectProps: {
        IconComponent: null,
      },
      filterSelectOptions: [
        { text: 'Commited', value: 'yes' },
        { text: 'Undecided', value: 'no' },
      ],
      filterFn: (row, id, filterValue) => { 
        if (filterValue === 'yes' && row.original.orderStatus) {
          return true
        }
        if (filterValue === 'no' && !row.original.orderStatus) {
          return true
        }
        return false
      },
      Cell: ({ row, cell }) => <Switch 
        checked={cell.getValue() !== 'no'} 
        onChange={(e) => {
          let commited = e.target.checked ? 1 : 0;
          let received = row.original.deliveries ? 1 : 0

          if (!commited) {
            received = 0
          }

          updateItem(row.original, { 
            deliveries: received,
            orderStatus: commited
          }, () => {
            // navigate("/products_reload");
          })
        }}
      />
    },
    { 
      id: 'deliveries',
      accessorKey: 'deliveries',
      accessorFn: (e) => e.deliveries?.[Object.keys(e.deliveries || {})?.[0]]?.deliveryDate ? e.deliveries : 'no',
      header: 'Received',
      enableColumnFilterModes: false,
      enableSorting: false,
      filterVariant: 'select',
      filterSelectOptions: [
        { label: 'Received', value: 'yes' },
        { label: 'On Order', value: 'no' },
      ],
      filterFn: (row, id, filterValue) => { 
        let contains_delivery_date = row?.original?.deliveries?.[Object.keys(row?.original?.deliveries || {})?.[0]]?.deliveryDate
        if (filterValue === 'yes' && (contains_delivery_date || row?.original?.deliveries === 1)) {
          return true
        }
        if (filterValue === 'no' && !contains_delivery_date) {
          return true
        }
        return false
      },
      Cell: ({ row, cell }) => <Switch 
        checked={cell.getValue() !== 'no'}
        onChange={(e) => {
          let received = e.target.checked ? 1 : 0;
          let commited = row.original.orderStatus

          if (received) {
            commited = 1
          }

          if (!row.original.deliveries && received) {
            row.original.deliveries = 1
          }

          updateItem(row.original, { 
            deliveries: received,
            orderStatus: commited,
          }, () => {
            // navigate("/products_reload");
          })
        }}
      />
    },
    {
      id: 'integrations',
      accessorKey: 'integrations',
      header: 'Sent to Shopify',
      filterVariant: 'select',
      filterSelectOptions: shopifyFilterOptions,
      filterFn: (row, id, filterValue) => { 
        if (filterValue === 'yes' && (row.original.integrations?.shopify?.product_id || row.original.integrations?.shopify_v2)) {
          return true
        }
        if (filterValue === 'no' && !row.original.integrations?.shopify?.product_id && !row.original.integrations?.shopify_v2) {
          return true
        }
        if (row.original.integrations?.shopify_v2?.[filterValue]) {
          return true
        }
        return false
      },
      accessorFn: (e) => e.integrations ? e.integrations : null,
      Cell: ({ row, cell }) => {
        let shopify_value = cell?.getValue()?.shopify || cell?.getValue()?.shopify_v1
        let shopify_v2_value = cell?.getValue()?.shopify_v2

        if (shopify_v2_value) {
          return (
            <div>
              {Object.keys(shopify_v2_value || []).map((shop) => {
                let product_id = shopify_v2_value[shop]?.product_id.replace('gid://shopify/Product/', '')
                let upload_date = shopify_v2_value[shop]?.upload_date
                return (
                  <Box key={`products-integration-${product_id}`}>
                    <Typography variant="button">
                        {accountIntegrations?.shopify_v2?.[shop]?.name || shop}
                    </Typography>
                    <div>
                      <Typography variant="caption">
                        Shopify id: {product_id}
                      </Typography>
                      <a href={`https://${shop}.myshopify.com/admin/products/${product_id}`} target="_blank" rel="noreferrer">
                        <OpenInNewIcon sx={{fontSize: 16}} color="primary" />
                      </a>
                    </div>
                    {upload_date && (
                      <div>
                        <Typography variant="caption">
                          Date sent: {moment(shopify_v2_value[shop]?.upload_date*1000).format("DD/MM/YYYY")}
                        </Typography>
                      </div>
                    )}
                  </Box>
                )
              })}
            </div>
          )
        }

        if (shopify_value?.product_id) {
          // Old shopify import support
          return (<div>
            <div>
              <Typography variant="caption">
                Shopify id: {cell.getValue()?.shopify?.product_id}
              </Typography>
              {accountIntegrations?.shopify?.domain ? (
                <a href={`https://${accountIntegrations?.shopify?.domain}/admin/products/${cell.getValue()?.shopify?.product_id}`} target="_blank" rel="noreferrer">
                  <OpenInNewIcon sx={{fontSize: 16}} color="primary" />
                </a>
              ):null}
            </div>
            <div>
              <Typography variant="caption">
                Date sent: {moment(cell.getValue()?.shopify?.upload_date*1000).format("DD/MM/YYYY")}</Typography>
            </div>
          </div>)
        }

        return null
      }
    }
    

    // TODO Remember to uncomment dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // ], [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [columnFilters, selectedSeasonitems, visibleItems, accountId, availableBrands, availableCategories, brands, colors, customCategories, rowSelection, selectedCategoryGroups, userCreatedBrands])

  const table = useMaterialReactTable({
    columns: columns,
    data: visibleItems,
    onRowSelectionChange: setRowSelection,
    getRowId: (originalRow) => originalRow.id,
    autoResetPageIndex: false,
    enableRowSelection: true,
    enableSelectAll: true,
    enableColumnActions: false,
    enableColumnOrdering: true,
    enableEditing: true,
    enableColumnFilterModes: false,
    enableDensityToggle: false,
    selectAllMode: "all",
    renderRowActions: ({ row, table }) => {
      let shopify_legacy_value = row?.original?.integrations?.shopify || row?.original?.integrations?.shopify_v1
      let shopify_value = row?.original?.integrations?.shopify_v2 || {}
      let shopify_stores = Object.keys(shopify_value) || []

      return (
        <Box key={row.id} sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
          <IconButton onClick={() => { setEditableProduct(row.original) }} id={`edit-${row.id}`} color="primary">
            <EditIcon />
          </IconButton>
          {shopify_stores.length > 0 ? (
            <div>
              {shopify_stores.length > 1 ? (
                <IconButton color="secondary">
                  <ShopifyIcon />
                </IconButton>
              ) : null}

              {shopify_stores.length === 1 ? (
                <a href={`https://${shopify_stores[0]}.myshopify.com/admin/products/${shopify_value[shopify_stores[0]].product_id}`} target="_blank" rel="noreferrer">
                  <IconButton color="secondary">
                    <ShopifyIcon />
                  </IconButton>
                </a>
              ) : null}
            </div>
          ) : null}
          {shopify_stores.length === 0 && accountIntegrations && shopify_legacy_value?.product_id && accountIntegrations?.shopify_v1?.domain ? (
            <a href={`https://${accountIntegrations?.shopify_v1?.domain}/admin/products/${shopify_legacy_value?.product_id}`} target="_blank" rel="noreferrer">
              <IconButton color="secondary">
                <ShopifyIcon />
              </IconButton>
            </a>
          ) : null}
        </Box>
      )
    },
    onColumnVisibilityChange: ((visibility) => {
      setColumnVisibility(visibility)
    }),
    onEditingRowCancel: ((event) => {
      reset_visible_items()
    }),
    icons: {
      DragHandleIcon: (props: any) => (
        <DragIndicatorIcon sx={{ color: '#6C737F' }} fontSize="small" {...props} />
      ),
      SyncAltIcon: (props: any) => (
        <SyncAltIcon sx={{ color: '#6C737F' }} fontSize="small" {...props} />
      ),
    },
    onPaginationChange: setPagination,
    onColumnOrderChange: setColumnOrder,
    onSortingChange: setSorting,
    state: {
      rowSelection,
      columnVisibility,
      sorting,
      pagination,
      columnFilters: columnFilters.map(filter => {
        if (['deliveryStart', 'deliveryEndDate'].indexOf(filter.id) !== -1) {
          filter.value = moment(filter.value)
        }
        return filter
      }),
      columnOrder,
      globalFilter,
      isFullScreen
    },
    localization: MRT_Localization_EN,
    initialState: { 
      showColumnFilters: true,
      showGlobalFilter: true,
      density: 'compact',
    },
    sortingFns: {
      dateSort: (rowA, rowB, columnId) => {
        let a = rowA.original[columnId]
        let b = rowB.original[columnId]
        return (a===null)-(b===null) || +(a>b)||-(a<b);
      },
      emptyFirstSort: (rowA, rowB, columnId) => {
        let a = rowA.original[columnId]
        let b = rowB.original[columnId]
        return (a===null)-(b===null) || +(a>b)||-(a<b);
      },
    },
    filterFns: {
      globalSearchFn2: (row, id, filterValue) => { return true },
      globalSearchFn: (row, id, filterValue) => {
        try {
          const note_found = row.getValue('note') && row.getValue('note')?.toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1
          const styleNumber_found = row.getValue('styleNumber') && row.getValue('styleNumber')?.toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1
          const styleName_found = row.getValue('styleName') && row.getValue('styleName')?.toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1
          const brand = (userCreatedBrands?.[row.getValue('brand')]?.displayName) || (brands?.[row.getValue('brand')]?.displayName) || "";
          const brand_found = brand?.toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1
          const category = (customCategories[row.getValue('category')] && customCategories[row.getValue('category')]?.category) || ""
          const category_found = category?.toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1
          const colors = row.getValue('color').filter(e => e.displayName.toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1)
          console.log('userCreatedBrands', userCreatedBrands)
          console.log('brands', brands)
          console.log(brand, '-', category)
  
          if (note_found || styleName_found || styleNumber_found || brand_found || category_found || colors.length) {
            return true
          }
        } catch(e) {
          console.log(e)
          setGlobalFilter('')
        }

        return false
      },
      colorFilter: (row, id, filterValue) => {
        if (filterValue.length === 0) {
          table.getColumn(id).setFilterValue('')
        }
        // This now acts as or filer
        // Need recursive search to match all if we want 'multi color match' finds
        if (!row.original.color) {
          return false
        }

        if (filterValue.length === 0) {
          return true
        }
 
        let found = false
        filterValue.forEach((selected) => {
          if (row.original.color?.indexOf(selected) !== -1) {
            found = true
            return true
          }
        })
        return found
      }
    },
    globalFilterFn: 'globalSearchFn2',
    manualFiltering: false,
    onGlobalFilterChange: setGlobalFilter,
    onIsFullScreenChange: setIsFullScreen,
    onColumnFiltersChange: setColumnFilters,
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        {selectedItems.length ? (
          <div style={{display: "flex"}}>
            <Typography fontWeight={"bold"} variant='body1'>{selectedItems.length} of {visibleItems.length} product(s) selected <Link color={"#ff3b53"} underline='none' sx={{p: 0, ml: 2, cursor: 'pointer', fontWeight: 'bold', fontSize: '16px'}} onClick={clearSelection}>Clear selection</Link></Typography>
          </div>
        ) : (
          <Typography variant="h3">Products</Typography>
        )}
      </>
    ),
    renderBottomToolbarCustomActions: ({ table }) => (
      <FAB createProduct={() => { setEditableProduct({ create: true, orderStatus: 1 }) }} isFullScreen={isFullScreen} clearSelection={clearSelection} selected={selectedItems.length > 0} items={selectedItems.length > 0 ? selectedItems : filteredItems || visibleItems} />
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <MRT_ToggleGlobalFilterButton table={table} />
        <Tooltip title={"Clear all filters"}>
          <IconButton 
            onClick={() => {
              console.log(table)
              table.resetColumnFilters()
              table.resetGlobalFilter()
              setSorting([])
            }}
          >
            {globalFilter?.length > 0 || columnFilters?.length > 0 ? (
              <FilterAltOffIcon sx={{fill: "#ff3b53"}} />
            ) : (
              <FilterAltOffIcon />
            )}
          </IconButton>
        </Tooltip>
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
      </>
    ),
    muiEditRowDialogProps: {
      disableEscapeKeyDown: false,
      onClose: () => {
        table.setEditingRow(null)
      }
    },
    muiTableContainerProps: {
      // sx: { maxHeight: lgUp ? "calc(100vh - 160px)" : "calc(100vh - 270px)" }
      // sx: {
      //   maxHeight: lgUp ? 
      //     (selectedItems.length ? "clamp(350px, calc(100vh - 211px), 9999px)" : "clamp(350px, calc(100vh - 152px), 9999px)") :
      //     (selectedItems.length ? "clamp(350px, calc(100vh - 211px - 64px), 9999px)" : "clamp(350px, calc(100vh - 152px - 64px), 9999px)")
      // }
    },
    muiTableBodyProps: {
      className: "table-body",
      sx: {
        overflow: "-moz-scrollbars-vertical",
        overflowY: "scroll",
        overflowX: "scroll"
      }
    },
    // muiTableHeadProps: { className: "table-header" },
    // muiTableFooterProps: { className: "table-footer" },
    muiTableProps: {},
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: 'none',
    muiTableHeadProps: {
      //simple styling with the `sx` prop, works just like a style prop in this example
      sx: {
        '.MuiSelect-icon': { display: 'none' }
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      onDoubleClick: (e) => {
        document.querySelector(`#edit-${row.id}`).click()
      }
    }),
    muiTopToolbarProps: {
      sx: {
        minHeight: '4rem'
      }
    }
  })

  useEffect(() => {
    try {
      // console.log('table', Object.keys(table.getState().rowSelection).map(item => table.getRow(item).original.priceInfo?.quantity))
      if (selectedSeasonitems && visibleItems.length > 0) {
        setSelectedItems(Object.keys(table.getState().rowSelection).map(item => table.getRow(item).original))
      }
    } catch (e) {
      // Handled error, when items are deleted the selected items are expected to fail, so just set selection to none
      console.log('selectedItemsError', e)
      setRowSelection([])
      setSelectedItems([])
    }
  }, [selectedSeasonitems, visibleItems, table, rowSelection])

  // Whenever filters change, set filtered items value so that it can be visible in the image grid view
  useEffect(() => {
    setFilteredItems(table.getFilteredRowModel().rows.map(e => e.original))
  }, [table, columnFilters, globalFilter, visibleItems])
    
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DashboardLayout style={{ padding: 0 }}>
        <MaterialReactTable table={table} />
        {editableProduct && (
          <Product
            product={editableProduct} 
            open={editableProduct ? true : false}
            onClose={() => {
              setEditableProduct(false)
            }}
            button={(
              <IconButton color="primary">
                <EditIcon />
              </IconButton>
            )} 
          />
        )}
      </DashboardLayout>
    </LocalizationProvider>
  );
};
